/*
 * @Description: 
 * @version: 1.0.0
 * @Author: Monkey
 * @Date: 2023-03-03 17:05:20
 * @LastEditors: Monkey
 * @LastEditTime: 2023-03-11 16:43:38
 */

//字典选择器配置

export default {
  // dicApiObj: API.system.dic.get,		//获取字典接口对象
  dicApiObj: '',		//获取字典接口对象
  parseData: function (res) {
    return {
      data: res.data,				//分析行数据字段结构
      msg: res.message,			//分析描述字段结构
      code: res.code				//分析状态字段结构
    }
  },
  request: {
    name: 'name'					//规定搜索字段
  },
  props: {
    label: 'label',					//映射label显示字段
    value: 'value',					//映射value值字段
  }
}
